import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { COMPANY } from '../constants';

const MentionsLegales = () => {
  useEffect(() => {
    document.title = "Mentions Légales | Reco Pneus";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="mentions-legales-page">
      <Header />
      
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Back Link */}
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-gray-500 hover:text-[#41DB23] text-sm mb-8 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Retour à l'accueil
          </Link>

          <h1 className="text-3xl sm:text-4xl font-black uppercase tracking-tighter text-gray-900 mb-8">
            Mentions Légales
          </h1>

          <div className="prose prose-gray max-w-none space-y-8">
            <section>
              <h2 className="text-xl font-bold text-[#41DB23] mb-4">1. Éditeur du site</h2>
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-6 text-gray-600">
                <p><strong className="text-gray-900">Raison sociale :</strong> Reco Pneus</p>
                <p><strong className="text-gray-900">Forme juridique et Raison sociale :</strong> SASU RC PNEUS</p>
                <p><strong className="text-gray-900">Siège social :</strong> 31 chemin des fades 06110 Le Cannet</p>
                <p><strong className="text-gray-900">SIRET :</strong> 100 484 369 000 10</p>
                <p><strong className="text-gray-900">Téléphone :</strong> 04 23 34 06 34</p>
                <p><strong className="text-gray-900">Email :</strong> recopneus@gmail.com</p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#41DB23] mb-4">2. Hébergeur</h2>
              <p className="text-gray-600">
                Le site est hébergé par : 1&amp;1 IONOS SARL<br />
                Adresse : 7 Place de la Gare — BP 70109 — 57200 Sarreguemines Cedex — France<br />
                Téléphone : 09 70 80 89 11
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#41DB23] mb-4">3. Propriété intellectuelle</h2>
              <p className="text-gray-600">
                L'ensemble du contenu de ce site (textes, images, vidéos, logos, icônes, sons, logiciels, etc.) 
                est la propriété exclusive de Reco Pneus ou de ses partenaires et est protégé par les lois 
                françaises et internationales relatives à la propriété intellectuelle.
              </p>
              <p className="text-gray-600 mt-4">
                Toute reproduction, représentation, modification, publication, transmission, dénaturation, 
                totale ou partielle du site ou de son contenu, par quelque procédé que ce soit, et sur 
                quelque support que ce soit est interdite sans l'autorisation écrite préalable de Reco Pneus.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#41DB23] mb-4">4. Limitation de responsabilité</h2>
              <p className="text-gray-600">
                Reco Pneus s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées 
                sur ce site, dont elle se réserve le droit de corriger le contenu à tout moment et sans préavis.
              </p>
              <p className="text-gray-600 mt-4">
                Reco Pneus décline toute responsabilité en cas de difficulté d'accès au site, de 
                contamination par virus ou d'autres éléments nuisibles, ou en cas de problème de 
                compatibilité entre ce site et votre navigateur ou tout autre logiciel.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#41DB23] mb-4">5. Liens hypertextes</h2>
              <p className="text-gray-600">
                Ce site peut contenir des liens vers d'autres sites web. Reco Pneus n'exerce aucun 
                contrôle sur ces sites et n'assume aucune responsabilité quant à leur contenu.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#41DB23] mb-4">6. Droit applicable</h2>
              <p className="text-gray-600">
                Les présentes mentions légales sont régies par le droit français. En cas de litige, 
                les tribunaux français seront seuls compétents.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#41DB23] mb-4">7. Contact</h2>
              <p className="text-gray-600">
                Pour toute question concernant ces mentions légales, vous pouvez nous contacter :<br />
                Email : {COMPANY.email}<br />
                Téléphone : {COMPANY.phone}
              </p>
            </section>
          </div>

          <p className="text-gray-400 text-sm mt-12">
            Dernière mise à jour : Avril 2026
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default MentionsLegales;
